import React from "react";
import { useSolrContext } from "@e-fork/solr";
import { FormattedMessage } from "react-intl";

const FiltersControlReset = () => {
  const { currentFilters, resetFilters } = useSolrContext();

  const isFiltered = !!currentFilters;

  const handleClick = (event) => {
    event.preventDefault();
    if (!isFiltered) return;
    resetFilters();
  };

  return (
    <button
      className="filters-control filters-control-reset btn btn-primary"
      disabled={!isFiltered}
      onClick={handleClick}
    >
      <FormattedMessage id="overview.controls.filter_reset.label" />
    </button>
  );
};

export default FiltersControlReset;
